import { useState } from 'react';

import { NotificationsStore } from './notifications.store';

type UseNotifyFactoryParams = ConstructorParameters<
  typeof NotificationsStore
>[0];

export const useNotifyFactory = (params?: UseNotifyFactoryParams) => {
  const [state] = useState(() => new NotificationsStore(params));

  return state;
};
